var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "s12 insety-16 border-bottom" }, [
    _c(
      "div",
      {
        staticClass: "after-16 before-8",
        class: { "flex-flex": _vm.$media.l },
      },
      [
        _c("div", { staticClass: "text-semibold mf-label" }, [
          _vm._v(
            _vm._s(_vm.$t("your_country")) + "/" + _vm._s(_vm.$t("region"))
          ),
        ]),
        _c(
          "div",
          { class: _vm.$media.l ? "start-32" : "before-16" },
          [
            _c("SelectDrop", {
              ref: "selectDrop",
              staticClass: "after-16 fund-fields",
              attrs: {
                options: _vm.countries,
                defaultValue: _vm.defaultCountry.value,
                filterFor: "residency",
              },
              on: { getSelect: _vm.showResidence },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }